<template>
  <button
    :class="[{
      [$style.dropDownButton]: !useLinkStyleForButton && !useDarkLinkStyleForButton,
      [$style.dropDownButtonDarkLinkStyle]: useDarkLinkStyleForButton && !disabled,
      [$style.dropDownButtonDisabled]: disabled,
      [$style.dropDownButtonLinkStyle]: useLinkStyleForButton,
      [$style.dropDownButtonLinkStyleActive]: active,
    }, $style.dropDownButtonPosition]"
    :disabled="disabled"
    @click="$emit('click')"
  >
    <slot />
    <CaretIcon
      v-if="includeCaret"
      :class="$style.caret"
    />
    <CloseIcon
      v-if="removable"
      ref="closeIcon"
      :class="$style.closeIcon"
      @click="handleCloseClick"
    />
  </button>
</template>

<script>
import CaretIcon from 'public/img/icons/caret.svg?inline';
import CloseIcon from 'public/img/icons/close.svg?inline';

export default {
  name: 'MultiSelectSearchButton',
  components: {
    CaretIcon,
    CloseIcon,
  },
  props: {
    active: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    includeCaret: {
      type: Boolean,
      default: true,
    },
    removable: {
      type: Boolean,
      default: false,
    },
    useDarkLinkStyleForButton: {
      type: Boolean,
      default: false,
    },
    useLinkStyleForButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    handleCloseClick() {
      this.$emit('close');
    },
  },
};
</script>

<style module>
@value (allTransition) from '~css/transitions.css';

button.dropDownButton {
  background-color: var(--jcGrey200);
  border-radius: 14px;
  color: var(--jc-text-color);
  cursor: pointer;
  padding: 5px 15px;
  transition: allTransition;
  white-space: nowrap;
}

button.dropDownButtonLinkStyle,
button.dropDownButtonDarkLinkStyle {
  background-color: transparent;
  padding: 4px 8px;
}

button.dropDownButtonLinkStyle {
  color: var(--jc-color-informational-base);
}

button.dropDownButtonDarkLinkStyle {
  color: var(--jc-text-color);
}

button.dropDownButtonPosition {
  align-items: var(--valueTextAlignItems);
  display: var(--valueTextPosition);
}

button.dropDownButton:hover,
button.dropDownButtonLinkStyleActive {
  background-color: var(--jcGrey800);
  color: white;
}

.caret {
  height: 8px;
  margin-left: 3px;
  opacity: 0.6;
  position: relative;
  transition: allTransition;
}

.caret:focus { outline: none; }
.dropDownButton:hover .caret { fill: white; }

.closeIcon {
  background-color: var(--jcGrey);
  border-radius: 50%;
  fill: white;
  height: 10px;
  margin-left: 6px;
  margin-right: -4px;
  opacity: 0.6;
  padding: 1px;
  position: relative;
  top: 1px;
  transition: allTransition;
}

.closeIcon:focus { outline: none; }
.closeIcon:hover { opacity: 0.8; }

.dropDownButton:hover .closeIcon {
  background-color: white;
  fill: var(--jcGrey);
}

.dropDownButtonDisabled:disabled {
  color: var(--jcGrey400);
  cursor: default !important;
}

.dropDownButtonDisabled:disabled:hover {
  background-color: var(--jcGrey200);
  color: var(--jcGrey400);
}

.dropDownButtonDisabled:hover .caret { fill: black; }
</style>
